import { render, staticRenderFns } from "./eduBefore.vue?vue&type=template&id=1bfdce02&scoped=true"
import script from "./eduBefore.vue?vue&type=script&lang=js"
export * from "./eduBefore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfdce02",
  null
  
)

export default component.exports